import React, { Component } from "react";
import { BoxDanger, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { Button, Container, Col, Row, Card, CardBody } from "design-react-kit";
import { networkErrorHelper } from "libs";
import { revisionService } from "libs/api/revisionService";
import { withRouter } from "react-router-dom";
import { MTextArea } from "components/forms";

class ReviewDetailLA extends Component {
  state = {
    loading: true,
    loadingError: false,
    lessonActivity: "",
    idLessonActivity: 0,
    revisionNote: "",
    revisionNoteError: false,
  };

  componentDidMount() {
    const idLessonActivity = parseInt(this.props.match.params.idLessonActivity) > 0 ? this.props.match.params.idLessonActivity : 0;
    this.setState({ idLessonActivity });
    this.loadRemote(idLessonActivity);
  }

  loadRemote(idLessonActivity) {
    revisionService
      .getLessonActivity(idLessonActivity)
      .then(({ data }) => {
        const { user, course, userCourse, lessonActivity, lessonActivityDetail } = data.payload;

        this.setState(() => ({
          loading: false,
          user,
          course,
          userCourse,
          lessonActivity,
          lessonActivityDetail,
        }));
      })
      .catch((error) => {
        if (networkErrorHelper.is404(error)) {
          this.pendingDraft = true;
        } else {
          networkErrorHelper.notify(error);
          this.setState({
            loadingError: true,
            loading: false,
          });
        }
      });
  }

  goBack() {
    window.history.back();
  }

  handleRevision(status) {
    const { idLessonActivity, revisionNote } = this.state;

    //if NON VALIDO and missing revisionNote
    if (status === "revisionPending" && (!revisionNote || revisionNote.trim() === "")) {
      this.setState({ revisionNoteError: true });
      return;
    }

    const payload = { idLessonActivity, status, revisionNote };

    revisionService
      .updateLessonActivity(payload)
      .then(() => {
        this.goBack();
      })
      .catch((error) => {
        console.error(error);
        networkErrorHelper.notify(error);
      });
  }

  toggleValid = () => {
    ModalHandler.show(null, "Conferma validità tirocinio", "Sei sicuro di voler contrassegnare questo tirocinio come VALIDO?", null, () =>
      this.handleRevision("revisioned"),
    );
  };

  toggleNotValid = () => {
    const { revisionNote } = this.state;

    if (!revisionNote || revisionNote.trim() === "") {
      this.setState({ revisionNoteError: true });
      return;
    }

    ModalHandler.show(null, "Conferma non validità tirocinio", "Sei sicuro di voler contrassegnare questo tirocinio come NON VALIDO?", null, () =>
      this.handleRevision("revisionPending"),
    );
  };

  render() {
    const { lessonActivityDetail, lessonActivity, user, userCourse, course, revisionNote, revisionNoteError, loading, loadingError } = this.state;

    const fileLabels = {
      progettoFormativo_signed: "Progetto formativo firmato",
      convenzione_signed: "Convenzione firmata",
      relazioneFinale: "Relazione finale",
      registroPresenze: "Registro presenze",
      grigliaAutovalutazione: "Griglia di autovalutazione",
      contrattoLavoro: "Contratto di lavoro",
      progettoFormativo: "Progetto formativo",
      schedaValutativa: "Scheda valutativa",
    };

    const fileCodes = Object.keys(fileLabels);

    const questions = lessonActivityDetail?.filter((activity) => !activity.fileUrl) || [];

    const schoolInfo = questions.filter((q) => q.field.includes("school"));

    const trainingInfo = questions.filter((q) => !q.field.includes("school") && q.field !== "isSchoolAccredited");

    const files = lessonActivityDetail?.filter((activity) => activity.fileUrl && fileCodes.includes(activity.question));

    const { status } = lessonActivity;

    return (
      <>
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : loadingError ? (
            <BoxDanger className="m-5">
              Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
            </BoxDanger>
          ) : (
            <Container>
              <Title>{"Revisione"}</Title>
              <Col lg={{ size: 12 }} className="text-right">
                <Button onClick={this.goBack} color="btn btn-primary bg-dark m-2 p-3">
                  Torna Indietro
                </Button>
              </Col>

              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <CardBody>
                  <b>Nome</b>: {user.name}
                  <br />
                  <b>Cognome</b>: {user.surname}
                  <br />
                  <b>Email</b>: {user.email}
                  <br />
                  <b>Codice Registrazione</b>: {userCourse.registrationCode}
                  <br />
                  <b>Titolo corso</b>: {course.title}
                  <br />
                  <b>Codice corso</b>: {course.code}
                </CardBody>
              </Card>
              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <CardBody>
                  <span
                    className={`
                  badge m-3 p-2 ${status === "confirmed" ? "badge-warning" : "badge-success"}`}
                  >
                    {status === "confirmed" ? "Confermato" : "Revisionato"}
                  </span>

                  {schoolInfo.length > 0 && (
                    <MnemoCallout className="mnemo-callout-info mb-3">
                      <h4 className="mb-3">Dati Istituto</h4>
                      {schoolInfo.map((activity, index) => (
                        <Row key={index}>
                          <p>
                            <b>{activity.question}</b>: {activity.answer}
                          </p>
                        </Row>
                      ))}
                    </MnemoCallout>
                  )}

                  {trainingInfo.length > 0 && (
                    <MnemoCallout className="mnemo-callout-info mb-3">
                      <h4 className="mb-3">Dati Tirocinio</h4>
                      {trainingInfo.map((activity, index) => (
                        <Row key={index}>
                          <p>
                            <b>{activity.question}</b>: {activity.answer}
                          </p>
                        </Row>
                      ))}
                    </MnemoCallout>
                  )}

                  {files.length > 0 && (
                    <MnemoCallout className="mnemo-callout-info">
                      <h4 className="mb-3">Documentazione</h4>
                      {files.map((activity, index) => (
                        <Row key={`file-${index}`} className="align-items-center mb-2">
                          <Col>
                            <p className="mb-0">
                              <b>{fileLabels[activity.question] || activity.question}: </b>
                              <a href={`${process.env.REACT_APP_API_URL}${activity.fileUrl}`} target="_blank" rel="noopener noreferrer">
                                {" "}
                                Visualizza file
                              </a>
                            </p>
                          </Col>
                        </Row>
                      ))}
                    </MnemoCallout>
                  )}

                  {status === "confirmed" && (
                    <>
                      <Row className="my-4 justify-content-end">
                        <Col xs="12" className="mb-3">
                          <MTextArea
                            label="Note revisione da inviare allo studente"
                            rows="5"
                            value={revisionNote}
                            invalid={revisionNoteError}
                            infoText="Le note sono obbligatorie se il tirocinio non è valido"
                            onChange={(index, value) =>
                              this.setState({
                                revisionNote: value,
                                revisionNoteError: false,
                              })
                            }
                          />
                        </Col>
                      </Row>
                      <Row className="my-4 justify-content-end">
                        <Col xs="auto">
                          <Button color="primary" className="m-2" onClick={() => this.toggleValid("revisioned")}>
                            Tirocinio diretto VALIDO
                          </Button>
                        </Col>
                        <Col xs="auto">
                          <Button color="danger" className="m-2" onClick={() => this.toggleNotValid("revisionPending")}>
                            Tirocinio diretto NON VALIDO
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Container>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewDetailLA);
